import React from 'react';
import { useAuth } from '@/providers/AuthProvider';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Lock, AlertTriangle, LogOut } from 'lucide-react';

export default function CreditLockout() {
  const { user, logout } = useAuth();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-red-50 to-orange-50 p-4" data-testid="credit-lockout-page">
      <Card className="max-w-lg w-full">
        <CardContent className="pt-8 pb-8 text-center space-y-6">
          <div className="mx-auto w-16 h-16 rounded-full bg-red-100 flex items-center justify-center">
            <Lock className="h-8 w-8 text-red-600" />
          </div>

          <div>
            <h1 className="text-2xl font-bold text-gray-900">Account Suspended</h1>
            <p className="text-muted-foreground mt-2">
              Your organization's account has been temporarily suspended due to insufficient credits.
            </p>
          </div>

          <div className="p-4 rounded-lg bg-amber-50 border border-amber-200 text-left">
            <div className="flex gap-2">
              <AlertTriangle className="h-5 w-5 text-amber-600 flex-shrink-0 mt-0.5" />
              <div>
                <p className="font-medium text-amber-800 text-sm">What happened?</p>
                <p className="text-sm text-amber-700 mt-1">
                  Credits are deducted monthly based on active loans. Your organization's credit balance
                  is insufficient to cover the monthly charges.
                </p>
              </div>
            </div>
          </div>

          <div className="p-4 rounded-lg bg-blue-50 border border-blue-200 text-left">
            <p className="font-medium text-blue-800 text-sm">How to resolve this?</p>
            {user?.is_tenant_admin ? (
              <p className="text-sm text-blue-700 mt-1">
                Please contact the <strong>platform administrator</strong> to arrange payment and restore your credits.
                Once your payment is processed and credits are added, your access will be restored automatically.
              </p>
            ) : (
              <p className="text-sm text-blue-700 mt-1">
                Please contact your <strong>company administrator</strong> and ask them to coordinate with the platform
                team to resolve the credit balance. Access will be restored once credits are replenished.
              </p>
            )}
          </div>

          <Button variant="outline" onClick={logout} data-testid="logout-btn">
            <LogOut className="mr-2 h-4 w-4" /> Sign Out
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
